// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__PugWK","shown":"Popup_shown__l-gPC","popup-text":"Popup_popup-text__pwmkP"};